"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeterIndex = /** @class */ (function () {
    function MeterIndex(payload) {
        this.meterId = payload.meterId;
        this.meterIndexId = payload.meterIndexId;
        this.indexValue = payload.indexValue;
        this.previousMeterIndexId = payload.previousMeterIndexId;
        this.readingDate = payload.readingDate;
        this.clientId = payload.clientId;
        this.deliveryPointId = payload.deliveryPointId;
        this.picture = payload.picture;
    }
    return MeterIndex;
}());
exports.default = MeterIndex;
